import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowsRotate,
  faBell,
  faBolt,
  faBriefcase,
  faBuilding,
  faCalendarDays,
  faCircleExclamation,
  faClipboardCheck,
  faClock,
  faComments,
  faEnvelope,
  faEuroSign,
  faFileInvoice,
  faFileSignature,
  faFlag,
  faGraduationCap,
  faHandshake,
  faHeart,
  faListCheck,
  faLocationDot,
  faMagnifyingGlass,
  faMessage,
  faPaperPlane,
  faPen,
  faPhone,
  faStar,
  faTruck,
  faUser,
  faUsers,
  faVideo
} from '@fortawesome/pro-solid-svg-icons'

/** Mirrors the backend `ActionTypeIcon` enum (Font Awesome 6 names). */
const actionTypeIcons: Record<string, IconDefinition> = {
  'list-check': faListCheck,
  phone: faPhone,
  'calendar-days': faCalendarDays,
  envelope: faEnvelope,
  message: faMessage,
  comments: faComments,
  'file-signature': faFileSignature,
  'file-invoice': faFileInvoice,
  handshake: faHandshake,
  briefcase: faBriefcase,
  building: faBuilding,
  user: faUser,
  users: faUsers,
  flag: faFlag,
  star: faStar,
  bell: faBell,
  clock: faClock,
  'clipboard-check': faClipboardCheck,
  'paper-plane': faPaperPlane,
  truck: faTruck,
  'graduation-cap': faGraduationCap,
  'magnifying-glass': faMagnifyingGlass,
  pen: faPen,
  bolt: faBolt,
  'location-dot': faLocationDot,
  video: faVideo,
  'euro-sign': faEuroSign,
  heart: faHeart,
  'circle-exclamation': faCircleExclamation,
  'arrows-rotate': faArrowsRotate
}

export const getActionTypeIcon = (
  icon?: string | null
): IconDefinition | null => (icon ? (actionTypeIcons[icon] ?? null) : null)
